
export const URL_BASE_STATICS = 'https://dqr0dycp2rovo.cloudfront.net/tilventis';